export function Other() {
    return (
        <div className="emptyContent">
            <h1>Nothing in here :)</h1>
        </div>
    );
}
